import { Controller } from '@hotwired/stimulus';

export default class extends Controller<HTMLElement> {
  static readonly targets = ['checkbox', 'accordion', 'textarea'];

  declare checkboxTarget: HTMLInputElement;
  declare accordionTarget: HTMLDetailsElement;
  declare textareaTarget: HTMLTextAreaElement;

  get open() {
    return this.checkboxTarget.checked;
  }

  set open(value: boolean) {
    this.checkboxTarget.checked = value;
  }

  initialize() {
    this.accordionTarget.addEventListener('toggle', this.handleAccordionToggle);
    this.checkboxTarget.addEventListener('change', this.applyState);
    this.applyState();
  }

  private applyState = () => {
    if (!this.open) {
      this.accordionTarget.open = false;
      this.handleAccordionToggle();
    }
  };

  private handleAccordionToggle = () => {
    if (!this.accordionTarget.open) {
      this.cleanFields();
    }
  };

  private cleanFields() {
    this.textareaTarget.value = '';
    this.textareaTarget.dispatchEvent(new Event('input', { bubbles: true }));
  }
}
